export default "__VITE_ASSET__BXUvk_Ui__"